<template functional>
  <div>
    <span
      v-for="bol in props.item.bols"
      :key="bol.id"
      class="cursor-pointer hover:text-blue-600"
      :data-action="'showBOL'"
      :data-bol-id="bol.id"
    >
      {{ bol.id }} <div class="f75">{{ bol.reference_no }}</div>
    </span>
  </div>
</template>

<script>
export default {
  name: "fltl-bols",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>
